import {useLocation, withRouter} from "react-router";
import React, {useContext, useEffect, useRef, useState} from 'react';
import AppNav from "./AppNav";
import 'react-toastify/dist/ReactToastify.css';
import {deleteAPI, downloadAPI, getAPI, patchAPI, postAPI, putAPI} from "../APIUtil";
import Button from "react-bootstrap/Button";
import {Card, Col, Container, Form, InputGroup, Modal, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker"
import {
  faCalendar,
  faFileDownload,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import {
  checkKey,
  dateformatDB,
  formatNumber,
  lpad,
  nvl,
  parseDate,
  toNull,
  onFocusText,
  dateformatDatePicker,
  toSingleByteNumberOnly,
  nextStatusByApprove,
  dispPayGrpStatus,
  startLoadingBtn,
  addField,
  finishLoadingBtn,
  amountFormatter,
  parseNumber,
  CONST_TAX_EXP_08,
  CONST_TAX_INC_08,
  CONST_TAX_EXEMPT,
  CONST_TAX_NON_TAX,
  CONST_TAX_EXP_10,
  CONST_TAX_INC_10,
  onKeyDownNext,
  sleepByPromise,
  dateformatYYYY_MM_DD,
  focusById,
  onKeyDownShortCut, rpad
} from "../CMUtil";
import AsyncSelect from "react-select/async";
import {Link, useHistory} from "react-router-dom";
import Toast, {error, success} from "../Toast";
import {PayGrpList} from "./common/PayGrpList";
import {ExpDtlLine} from "./ExpDtlLine";
import {GlobalContext} from "../Global";
import {ApproveList} from "./common/ApproveList";
import {PayDateDialog} from "./common/PayDate";
import {RoutePaths} from "./PageRoutesAuthenticated";
import {RoyDtlLine} from "./RoyDtlLine";

export const RoyDtl = ({match: {params: {roy_id}}}) => {

  const history = useHistory();

  const {loginUser, setLoginUser} = useContext(GlobalContext);

  const [accList, setAccList] = useState([]);
  const [remarkList, setRemarkList] = useState([]);
  const [deptList, setDeptList] = useState([]);
  const [itemList, setItemList] = useState([]);

  const [sysConsumptionTaxCl, setSysConsumptionTaxCl] = useState("");
  const [sysRoundingOffCl, setSysRoundingOffCl] = useState("");

  const [selectMenuOpen, setSelectMenuOpen] = useState(false);

  //支払ヘッダ
  const [royId, setRoyId] = useState("");
  const [expDate, setExpDate] = useState("");
  const [payDate, setPayDate] = useState("");
  const [status, setStatus] = useState("");
  const [payGrpType, setPayGrpType] = useState("印税");
  const [payGrpNum, setPayGrpNum] = useState("");
  const [royTypeCdSelected, setRoyTypeCdSelected] = useState(null);
  const [royTypeCd, setRoyTypeCd] = useState("");
  const [itemSelected, setItemSelected] = useState(null);
  const [itemCd, setItemCd] = useState("");
  const [volumeNoMagezineCd, setVolumeNoMagezineCd] = useState("");
  const [volumeNoSerialNumber, setVolumeNoSerialNumber] = useState("");
  const [costCd, setCostCd] = useState("");
  const [version, setVersion] = useState("");
  const [countryCdSelected, setCountryCdSelected] = useState(null);
  const [countryCd, setCountryCd] = useState("");
  const [publisherCdSelected, setPublisherCdSelected] = useState(null);
  const [publisherCd, setPublisherCd] = useState("");
  const [agentCdSelected, setAgentSelected] = useState(null);
  const [agentCd, setAgentCd] = useState("");
  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");
  const [receiveAmount, setReceiveAmount] = useState("");

  //内訳
  const [lineList, setLineList] = useState([]);
  const lineListRef = useRef([]);
  const ini = useRef(true);
  const iniPayDate = useRef(true);

  const [authorCd, setAuthorCd] = useState("");

  const [subAmount, setSubAmount] = useState(0);
  const [subAmount10, setSubAmount10] = useState(0);
  const [subAmountEx1, setSubAmountEx1] = useState(0);
  const [subAmountEx2, setSubAmountEx2] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [taxAmount10, setTaxAmount10] = useState(0);
  const [taxAmountEx1, setTaxAmountEx1] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [withholdTaxAmount, setWithholdTaxAmount] = useState(0);
  const [payAmount, setPayAmount] = useState(0);

  const [dispCount, setDispCount] = useState(1);

  // 確認ダイアログ
  const [confirmModalShow, setConfirmModalShow] = useState(false);

  const asyncSelectStyles = {
    option: (base, {data}) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
    singleValue: (base, {data}) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
  };

  // ショートカットキー：Ctl＋Enter
  const onKeyDownCtlEnter = async (e) => {
    if (!isBtnPaySaveDisabled) {
      e.preventDefault();
      await onClickPaySave();
    }
  }

  // ショートカットキー：Escape
  const onKeyDownEsc = async (e) => {
    if (e.target && e.target.id === "expDate") {
      e.preventDefault();
      history.push(RoutePaths.root.roy_list);　//前画面に戻る
    } else {
      e.preventDefault();
      await focusById("expDate");
    }
  }

  // ショートカットキー：Space
  const onKeyDownSpace = async (e) => {
    if (e && e.target && e.target.getAttribute("author_cd")) {
      //編集ダイアログ
      e.preventDefault();
      await onClickShowModal(e.target.getAttribute("author_cd"));
    }
    if (e && e.target && e.target.id === "btn-pay-add") {
      //新規ダイアログ
      e.preventDefault();
      await onClickShowModal();
    }
  }

  // ショートカットキー：Enter
  const onKeyDownEnter = async (e) => {
    await onKeyDownNext(e);
  }

  // カレンダー用 ////////////////////////////////////////////////////////////////////////////////////////
  const [openCalExpDate, setOpenCalExpDate] = useState(false);
  const handleChangeCalExpDate = async (dateObj) => {
    setExpDate(dateformatYYYY_MM_DD(dateObj))
    setOpenCalExpDate(false);
    await focusById("expDate");
  };

  const [openCalPayDate, setOpenCalPayDate] = useState(false);
  const handleChangeCalPayDate = async (dateObj) => {
    setPayDate(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDate(false);
    await focusById("payDate");
  };

  // HOOKイベント ///////////////////////////////////////////////////////////////////////////
  useEffect(() => {

    const update = async () => {
      setRoyId(roy_id);
    }
    update();

  }, []);

  useEffect(() => {

    if (ini.current) {
      ini.current = false;
      return;
    }

    const update = async () => {
      let cPayDate = "";
      let cExpDate = "";
      let cPayGrpNum = "";
      let cStatus = "";
      let cRoyTypeCd = "";
      let cRoyTypeSelected = null;
      let cItemCd = "";
      let cItemSelected = null;
      let cVolumeNoMagezineCd = "";
      let cVolumeNoSerialNumber = "";
      let cCostCd = "";
      let cVersion = "";
      let cCountryCd = "";
      let cCountryCdSelected = null;
      let cPublisherCd = "";
      let cPublisherCdSelected = null;
      let cAgentCd = "";
      let cAgenSelected = null;
      let cQty = 0;
      let cPrice = 0;
      let cReceiveAmount = 0;
      let cSubAmount = 0;
      let cSubAmount10 = 0;
      let cSubAmountEx1 = 0;
      let cSubAmountEx2 = 0;
      let cTaxAmount = 0;
      let cTaxAmount10 = 0;
      let cTaxAmountEx1 = 0;
      let cTotalAmount = 0;
      let cWithholdTaxAmount = 0;
      let cPayAmount = 0;

      let cLineList = [];

      // 印税システム管理マスタ
      //　支払情報
      if (!royId) {
        cExpDate = dateformatDB(new Date());
      } else {
        let obj = await getAPI("tr_roy/" + royId);
        cPayDate = obj.pay_date;
        cPayGrpNum = nvl(obj.pay_grp_num);
        cExpDate = obj.exp_date;
        cStatus = nvl(obj.status);
        cRoyTypeCd = nvl(obj.roy_type_cd);
        cItemCd = nvl(obj.item_cd);
        cVolumeNoMagezineCd = nvl(obj.volume_no_magezine_cd);
        cVolumeNoSerialNumber = nvl(obj.volume_no_serial_number);
        cCostCd = nvl(obj.cost_cd);
        cVersion = nvl(obj.ver);
        cCountryCd = nvl(obj.country_cd);
        cPublisherCd = nvl(obj.publisher_cd);
        cAgentCd = nvl(obj.agent_cd);
        cQty = nvl(obj.qty, "");
        cPrice = nvl(obj.price, "");
        cReceiveAmount = nvl(obj.receive_amount, "");
        cSubAmount = nvl(obj.sub_amount, "");
        cSubAmount10 = nvl(obj.sub_amount_10, "");
        cSubAmountEx1 = nvl(obj.sub_amount_ex1, "");
        cSubAmountEx2 = nvl(obj.sub_amount_ex2, "");
        cTaxAmount = nvl(obj.tax_amount, "");
        cTaxAmount10 = nvl(obj.tax_amount_10, "");
        cTaxAmountEx1 = nvl(obj.tax_amount_ex1, "");
        cTotalAmount = nvl(obj.total_amount, "");
        cWithholdTaxAmount = nvl(obj.withholding_tax_amount, "");
        cPayAmount = nvl(obj.pay_amount, "");

        if (cRoyTypeCd) {
          let c = await getAPI("ms_code_search_view",{
            code_type: "印税種別",
            code : cRoyTypeCd
          });
          c = c.results[0];
          cRoyTypeSelected = {name: c.code + " " + nvl(c.code_name), id: c.code};
        }
        if (cItemCd) {
          const ciObj = await getAPI("ms_item/" + cItemCd);
          cItemSelected = {name: nvl(cItemCd) + " " + nvl(ciObj.item_name), id: cItemCd, fixed_price_1: ciObj.fixed_price_1};
        }
        if (cCountryCd) {
          let cc = await getAPI("ms_code_search_view", {
            code_type: "国コード",
            code: cCountryCd
          });
          cc = cc.results[0];
          cCountryCdSelected = {name: cc.code + " " + nvl(cc.code_name), id: cc.code};
        }
        if (cPublisherCd) {
          let cp = await getAPI("ms_code_search_view", {
            code_type: "出版社コード",
            code: cPublisherCd
          });
          cp = cp.results[0];
          cPublisherCdSelected = {name: cp.code + " " + nvl(cp.code_name), id: cp.code};
        }
        if (cAgentCd) {
          let ca = await getAPI("ms_code_search_view", {
            code_type: "代理店コード",
            code: cAgentCd
          });
          ca = ca.results[0];
          cAgenSelected = {name: ca.code + " " + nvl(ca.code_name), id: ca.code};
        }

        //内訳
        let searchCondition = {
          roy_id: royId
        }
        let res = await getAPI("tr_roy_dtl_list_search_view", searchCondition);
        cLineList = res.results;
      }
      while (cLineList.length <= 4) {
        cLineList.push({
          index: cLineList.length,
          roy_id: toNull(royId),
          roy_dtl_id: null,
          acc_cd: null,
          author_cd: null,
          pay_type_cd: null,
          bank_cd: null,
          bank_branch_cd: null,
          kind_of_account_cl: null,
          bank_account_no: null,
          line_pay_rate: null,
          line_amount: null,
          line_amount_ex_1: null,
          line_amount_ex_2: null,
          line_tax_rate: null,
          line_tax_amount: null,
          line_total_amount: null,
          line_withhold_tax_amount: null,
          line_pay_amount: null,
          remark_cd: null,
          note: null
        });
      }

      setPayDate(cPayDate);
      setPayGrpNum(cPayGrpNum);
      setExpDate(cExpDate);
      setStatus(cStatus);
      setRoyTypeCd(cRoyTypeCd);
      setRoyTypeCdSelected(cRoyTypeSelected);
      setItemCd(cItemCd);
      setItemSelected(cItemSelected);
      setVolumeNoMagezineCd(cVolumeNoMagezineCd);
      setVolumeNoSerialNumber(cVolumeNoSerialNumber);
      setCostCd(cCostCd);
      setVersion(cVersion);
      setCountryCd(cCountryCd);
      setCountryCdSelected(cCountryCdSelected);
      setPublisherCd(cPublisherCd);
      setPublisherCdSelected(cPublisherCdSelected);
      setAgentCd(cAgentCd);
      setAgentSelected(cAgenSelected);
      setQty(cQty ? amountFormatter(cQty) : "");
      setPrice(cPrice ? amountFormatter(cPrice) : "");
      setReceiveAmount(cReceiveAmount ? amountFormatter(cReceiveAmount) : "");
      setSubAmount(cSubAmount);
      setSubAmount10(cSubAmount10);
      setSubAmountEx1(cSubAmountEx1);
      setSubAmountEx2(cSubAmountEx2);
      setTaxAmount(cTaxAmount);
      setTaxAmount10(cTaxAmount10);
      setTaxAmountEx1(cTaxAmountEx1);
      setTotalAmount(cTotalAmount);
      setWithholdTaxAmount(cWithholdTaxAmount);
      setPayAmount(cPayAmount);

      let searchCondition = {};
      let res = null;
      // // 科目リスト
      searchCondition = {search_value: ""};
      res = await getAPI("ms_acc1_typeahead_view", searchCondition);
      const cAccList = [];
      for (const obj of res.results) {
        cAccList.push({
          name: lpad(nvl(obj.acc_cd), 3, "0") + " " + nvl(obj.acc_nm),
          id: obj.acc_cd
        });
      }
      setAccList(cAccList);

      // 摘要リスト
      searchCondition = {remark_nm: ""};
      res = await getAPI("ms_remark_typeahead_view", searchCondition);
      const cRemarkList = [];
      for (const obj of res.results) {
        cRemarkList.push({
          name: nvl(obj.remark_cd) + " " + nvl(obj.remark_nm),
          id: obj.remark_cd,
          remark_nm: nvl(obj.remark_nm)
        });
      }
      setRemarkList(cRemarkList);

      lineListRef.current = [];
      for (let i = 0; i < cLineList.length; i++) {
        lineListRef.current[i] = React.createRef();
      }
      setLineList(cLineList);

      // await sleepByPromise(0.02);
      $("#expDate").select();
    }

    update();

  }, [royId, dispCount]);

  useEffect(() => {

    if (iniPayDate.current) {
      iniPayDate.current = false;
      return;
    }

    const update = async () => {

      if (!payDate) {
        return;
      }

      let searchCondition = {};
      // グループセット
      searchCondition = {
        pay_grp_type: "経費",
        pay_date: dateformatDB(payDate),
        selected: true
      }
      let res = await getAPI("ms_pay_grp", searchCondition);
      if (res.count >= 1) {
        // 選択中グループがある場合
        // 新規作成時のみ Gno を自動セット（修正時は手入力のみ変更可）
        if (!royId) {
          setPayGrpNum(res.results[0].pay_grp_num);
        }

      } else {
        // 選択中グループがない場合
        // 新規作成時のみ Gno を自動セット（修正時は手入力のみ変更可）
        if (!royId) {
          searchCondition = {
            pay_grp_type: "経費",
            pay_date: toNull(dateformatDB(payDate)),
            sort_field: "pay_grp_num",
            sort_order: "desc"
          }
          res = await getAPI("ms_pay_grp", searchCondition);
          if (res.count >= 1) {
            setPayGrpNum(res.results[0].pay_grp_num + 1);
          } else {
            setPayGrpNum(1);
          }
        }
      }
    }

    update();

  }, [payDate]);

  // 内訳画面 ////////////////////////////////////////////////////////////////////////////////////
  const onSearchRoyTypeCd = async (query) => {
    let searchCondition = {
      code_type: "印税種別",
      search_value: query,
    }
    const res = await getAPI("ms_code_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: obj.value + " " + nvl(obj.code_name),
      id: obj.value
    }));
    return o;
    await onKeyDownNext();
  }

  const handleChangeRoyTypeCd = async (value) => {
    setRoyTypeCdSelected(value);
    setRoyTypeCd(value ? value.id : "");
    if (value && value.id === "03") {
      setQty("");
    }
    onKeyDownNext();
  }

  const onSearchCountryCd = async (query) => {
    let searchCondition = {
      code_type: "国コード",
      search_value: query,
    }
    const res = await getAPI("ms_code_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: obj.value + " " + nvl(obj.code_name),
      id: obj.value
    }));
    return o;
    await onKeyDownNext();
  }

  const handleChangeCountryCd = async (value) => {
    setCountryCdSelected(value);
    setCountryCd(value ? value.id : "");
    onKeyDownNext();
  }

  const onSearchPublisherCd = async (query) => {
    let searchCondition = {
      code_type: "出版社コード",
      search_value: query,
    }
    const res = await getAPI("ms_code_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: obj.value + " " + nvl(obj.code_name),
      id: obj.value
    }));
    return o;
    await onKeyDownNext();
  }

  const handleChangePublisherCd = async (value) => {
    setPublisherCdSelected(value);
    setPublisherCd(value ? value.id : "");
    onKeyDownNext();
  }

  const onSearchAgentCd = async (query) => {
    let searchCondition = {
      code_type: "代理店コード",
      search_value: query,
    }
    const res = await getAPI("ms_code_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: obj.value + " " + nvl(obj.code_name),
      id: obj.value
    }));
    return o;
    await onKeyDownNext();
  }

  const handleChangeAgentCd = async (value) => {
    setAgentSelected(value);
    setAgentCd(value ? value.id : "");
    onKeyDownNext();
  }

  const onSearchItem = async (query) => {
    if (!query) {
      return [];
    }
    let searchCondition = {
      search_value: query
    }
    const res = await getAPI("ms_item_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: nvl(obj.item_cd) + " " + nvl(obj.item_name),
      id: obj.item_cd,
      fixed_price_1: obj.fixed_price_1
    }));
    return o;
  }

  const handleChangeItem = async (value) => {
    setItemSelected(value);
    setItemCd(value ? value.id : "");
    if (!value) {
      return;
    }

    if (value.fixed_price_1 != null) {
      setPrice(amountFormatter(value.fixed_price_1));
    }

    onKeyDownNext();
  }

  const onClickExpSave = async () => {

    // 入力チェック
    if (!expDate) {
      error("処理日を入力してください");
      return
    }
    if (!payDate) {
      error("支払日を入力してください");
      return
    }
    if (!payGrpNum) {
      error("Gnoを入力してください");
      return
    }

    let obj = {};
    let cRoyId = royId;
    // グループ作成
    if (payDate) {
      let searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: dateformatDB(parseDate(payDate)),
        pay_grp_num: payGrpNum
      }
      let res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (res.count === 0) {
        // グループ追加
        obj = {
          pay_grp_type: payGrpType,
          pay_date: dateformatDB(parseDate(payDate)),
          pay_grp_num: payGrpNum,
          status: "支払前",
          selected: true
        }
        obj = await postAPI("ms_pay_grp/", obj);
      }

      // 選択中を解除
      searchCondition = {
        pay_grp_type: payGrpType,
        selected: true
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      for (let payGrp of res.results) {
        if (payGrp.pay_grp_type === payGrpType && payGrp.pay_date === dateformatDB(parseDate(payDate)) && payGrp.pay_grp_num === payGrpNum) {
          //今回利用分はスキップ
          continue;
        }
        payGrp.selected = false;
        payGrp = await putAPI("ms_pay_grp/" + payGrp.pay_grp_id + "/", payGrp);
      }

      // 選択中にする
      searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: dateformatDB(parseDate(payDate)),
        pay_grp_num: payGrpNum
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (!res.results[0].selected) {
        let cPayGrp = res.results[0];
        cPayGrp.selected = true;
        cPayGrp = await putAPI("ms_pay_grp/" + cPayGrp.pay_grp_id + "/", cPayGrp);
      }
    }

    obj = {};
    if (!cRoyId) {
      //新規登録
      obj.pay_date = toNull(payDate);
      obj.pay_grp_type = toNull(payGrpType);
      obj.pay_grp_num = toNull(payGrpNum);
      obj.exp_date = toNull(expDate);
      obj.status = '支払前';
      obj.roy_type_cd = toNull(royTypeCd);
      obj.item_cd = toNull(itemCd);
      obj.volume_no_magezine_cd = toNull(volumeNoMagezineCd);
      obj.volume_no_serial_number = toNull(volumeNoSerialNumber);
      obj.cost_cd = toNull(costCd);
      obj.ver = toNull(version);
      obj.country_cd = toNull(countryCd);
      obj.publisher_cd = toNull(publisherCd);
      obj.agent_cd = toNull(agentCd);
      obj.qty = toNull(parseNumber(qty));
      obj.price = toNull(parseNumber(price));
      obj.receive_amount = toNull(parseNumber(receiveAmount));
      obj.sub_amount = toNull(subAmount);
      obj.sub_amount_10 = toNull(subAmount10);
      obj.sub_amount_ex1 = toNull(subAmountEx1);
      obj.sub_amount_ex2 = toNull(subAmountEx2);
      obj.tax_amount = toNull(taxAmount);
      obj.tax_amount_10 = toNull(taxAmount10);
      obj.tax_amount_ex1 = toNull(taxAmountEx1);
      obj.total_amount = toNull(totalAmount);
      obj.withholding_tax_amount = toNull(withholdTaxAmount);
      obj.pay_amount = toNull(payAmount);
      obj = await postAPI("tr_roy/", obj);
      cRoyId = obj.roy_id;
    } else {
      //更新
      obj.pay_date = toNull(payDate);
      obj.pay_grp_type = toNull(payGrpType);
      obj.pay_grp_num = toNull(payGrpNum);
      obj.exp_date = toNull(expDate);
      obj.status = '支払前';
      obj.roy_type_cd = toNull(royTypeCd);
      obj.item_cd = toNull(itemCd);
      obj.volume_no_magezine_cd = toNull(volumeNoMagezineCd);
      obj.volume_no_serial_number = toNull(volumeNoSerialNumber);
      obj.cost_cd = toNull(costCd);
      obj.ver = toNull(version);
      obj.country_cd = toNull(countryCd);
      obj.publisher_cd = toNull(publisherCd);
      obj.agent_cd = toNull(agentCd);
      obj.qty = toNull(parseNumber(qty));
      obj.price = toNull(parseNumber(price));
      obj.receive_amount = toNull(parseNumber(receiveAmount));
      obj.sub_amount = toNull(subAmount);
      obj.sub_amount_10 = toNull(subAmount10);
      obj.sub_amount_ex1 = toNull(subAmountEx1);
      obj.sub_amount_ex2 = toNull(subAmountEx2);
      obj.tax_amount = toNull(taxAmount);
      obj.tax_amount_10 = toNull(taxAmount10);
      obj.tax_amount_ex1 = toNull(taxAmountEx1);
      obj.total_amount = toNull(totalAmount);
      obj.withholding_tax_amount = toNull(withholdTaxAmount);
      obj.pay_amount = toNull(payAmount);
      obj = await patchAPI("tr_roy/" + cRoyId + "/", obj);
    }

    let cLineList = [];
    lineListRef.current.map(lineList => {
      cLineList.push(lineList.current.getStates());
    });
    cLineList = await lineBulkSave(cRoyId, cLineList);

    // 採番済みの明細IDを各行に反映（2回目以降の保存で再登録されないようにする）
    cLineList.forEach(savedLine => {
      const lineRef = lineListRef.current[savedLine.line_no - 1];
      if (lineRef && lineRef.current) {
        lineRef.current.setSavedIds(savedLine.roy_id, savedLine.roy_dtl_id);
      }
    });

    const isExistingRecord = !!royId;
    history.push("/roy_dtl/" + cRoyId + "/");
    setRoyId(cRoyId);
    if (isExistingRecord) {
      setDispCount(dispCount + 1);
    }
    success("保存しました");
  }

  const lineBulkSave = async (cRoyId, cLineList) => {

    let updatedLineList = [];
    for (let i = 0; i < cLineList.length; i++) {
      let cLine = cLineList[i];
      let obj = {};
      if (!cLine.roy_dtl_id) {
        obj.roy_id = cRoyId;
        obj.line_no = i + 1;
        obj.acc_cd = toNull(cLine.acc_cd);
        obj.author_cd = toNull(cLine.author_cd);
        obj.pay_type_cd = toNull(cLine.pay_type_cd);
        obj.bank_cd = toNull(cLine.bank_cd);
        obj.bank_branch_cd = toNull(cLine.bank_branch_cd);
        obj.kind_of_account_cl = toNull(cLine.kind_of_account_cl);
        obj.bank_account_no = toNull(cLine.bank_account_no);
        obj.bank_account_nm = toNull(cLine.bank_account_nm);
        obj.line_pay_rate = toNull(cLine.line_pay_rate);
        obj.line_amount = toNull(cLine.line_amount);
        obj.line_amount_ex_1 = toNull(cLine.line_amount_ex_1);
        obj.line_tax_rate = toNull(cLine.line_tax_rate);
        obj.line_tax_amount = toNull(cLine.line_tax_amount);
        obj.line_amount_ex_2 = toNull(cLine.line_amount_ex_2);
        obj.line_total_amount = toNull(cLine.line_total_amount);
        obj.line_withhold_tax_amount = toNull(cLine.line_withhold_tax_amount);
        obj.line_pay_amount = toNull(cLine.line_pay_amount);
        obj.remark_cd = toNull(cLine.remark_cd);
        obj.note = toNull(cLine.note);
        obj.create_pg = toNull(cLine.create_pg);
        obj.update_pg = toNull(cLine.update_pg);
        if (!obj.acc_cd && !obj.author_cd && !obj.pay_type_cd && !obj.line_pay_rate &&
          !obj.line_amount && !obj.line_amount_ex_1 && !obj.line_tax_rate && !obj.line_tax_amount &&
          !obj.line_amount_ex_2 && !obj.line_total_amount && !obj.line_withhold_tax_amount && !obj.line_pay_amount &&
          !obj.remark_cd && !obj.note) {
          //スキップ
          continue;
        }
        //明細追加
        obj = await postAPI("tr_roy_dtl/", obj);
      } else {
        //更新
        obj = await getAPI("tr_roy_dtl/" + cLine.roy_dtl_id);
        obj.roy_id = cRoyId;
        obj.line_no = i + 1;
        obj.acc_cd = toNull(cLine.acc_cd);
        obj.author_cd = toNull(cLine.author_cd);
        obj.pay_type_cd = toNull(cLine.pay_type_cd);
        obj.bank_cd = toNull(cLine.bank_cd);
        obj.bank_branch_cd = toNull(cLine.bank_branch_cd);
        obj.kind_of_account_cl = toNull(cLine.kind_of_account_cl);
        obj.bank_account_no = toNull(cLine.bank_account_no);
        obj.bank_account_nm = toNull(cLine.bank_account_nm);
        obj.line_pay_rate = toNull(cLine.line_pay_rate);
        obj.line_amount = toNull(cLine.line_amount);
        obj.line_amount_ex_1 = toNull(cLine.line_amount_ex_1);
        obj.line_tax_rate = toNull(cLine.line_tax_rate);
        obj.line_tax_amount = toNull(cLine.line_tax_amount);
        obj.line_amount_ex_2 = toNull(cLine.line_amount_ex_2);
        obj.line_total_amount = toNull(cLine.line_total_amount);
        obj.line_withhold_tax_amount = toNull(cLine.line_withhold_tax_amount);
        obj.line_pay_amount = toNull(cLine.line_pay_amount);
        obj.remark_cd = toNull(cLine.remark_cd);
        obj.note = toNull(cLine.note);
        obj.update_pg = toNull(cLine.update_pg);
        obj = await putAPI("tr_roy_dtl/" + cLine.roy_dtl_id + "/", obj);
      }
      updatedLineList.push(obj);
    }
    return updatedLineList;
  }

  const appendLine = async () => {
    let emptyLineCnt = 0;
    lineListRef.current.map(lineList => {
      if (lineList.current.isEmpty()) {
        emptyLineCnt += 1;
      }
    });

    if (emptyLineCnt < 1) {
      let cLineList = lineList;
      cLineList = JSON.parse(JSON.stringify(cLineList));
      cLineList.push({
        index: cLineList.length,
        roy_id: toNull(royId),
        exp_dtl_id: null,
        expense_cl: null,
        dept_cd: null,
        line_tax_type_cd: null,
        line_amount: null,
        line_tax_amount: null,
        line_total_amount: null,
        line_withhold_tax_amount: null,
        line_pay_amount: null,
        item_cd: null,
        cost_cd: null,
        remark_cd: null,
        note: null
      });
      lineListRef.current[lineListRef.current.length] = React.createRef();
      setLineList(cLineList);
    }
  }

  // 合計集計
  const calcTotal = async () => {
    let cLineList = [];
    lineListRef.current.map(lineList => {
      if (lineList.current.getStates().index == null) {
        return undefined;
      }
      cLineList.push(lineList.current.getStates());
    });

    // 集計
    let cSubAmount = 0;
    let cSubAmount10 = 0;
    let cSubAmountEx1 = 0;
    let cSubAmountEx2 = 0;
    let cTaxAmount = 0;
    let cTaxAmount10 = 0;
    let cTaxAmountEx1 = 0;
    let cTotalAmount = 0;
    let cWithholdTaxAmount = 0;
    let cPayAmount = 0;
    for (let i = 0; i < cLineList.length; i++) {
      const line = cLineList[i];
      const lineAmount    = line.line_amount             ? line.line_amount             : 0;
      const lineAmountEx1 = line.line_amount_ex_1        ? line.line_amount_ex_1        : 0;
      const lineAmountEx2 = line.line_amount_ex_2        ? line.line_amount_ex_2        : 0;
      const lineTaxRate   = line.line_tax_rate           ? line.line_tax_rate           : 0;
      cSubAmount        += lineAmount;
      cSubAmount10      += lineAmount;
      cSubAmountEx1     += lineAmountEx1;
      cSubAmountEx2     += lineAmountEx2;
      cTaxAmount        += line.line_tax_amount          ? line.line_tax_amount          : 0;
      cTaxAmount10      += Math.floor(lineAmount    * lineTaxRate / 100);
      cTaxAmountEx1     += Math.floor(lineAmountEx1 * lineTaxRate / 100);
      cTotalAmount      += line.line_total_amount        ? line.line_total_amount        : 0;
      cWithholdTaxAmount += line.line_withhold_tax_amount ? line.line_withhold_tax_amount : 0;
      cPayAmount        += line.line_pay_amount          ? line.line_pay_amount          : 0;
    }
    setSubAmount(cSubAmount);
    setSubAmount10(cSubAmount10);
    setSubAmountEx1(cSubAmountEx1);
    setSubAmountEx2(cSubAmountEx2);
    setTaxAmount(cTaxAmount);
    setTaxAmount10(cTaxAmount10);
    setTaxAmountEx1(cTaxAmountEx1);
    setTotalAmount(cTotalAmount);
    setWithholdTaxAmount(cWithholdTaxAmount);
    setPayAmount(cPayAmount);
  }

  // 確認ダイアログ //////////////////////////////////////////////////////////////////////////
  const onClickShowConfirmModal = async () => {
    setConfirmModalShow(true);
  }

  const onClickCloseConfirmModal = async () => {
    setConfirmModalShow(false);
  }

  const onClickDelete = async () => {
    // ヘッダのみ論理削除（明細は物理削除しない。BAPAYDTの削除フラグはサーバ側で処理）
    await deleteAPI("tr_roy/" + royId + "/", {delete_pg: "RoyDtl"});
    setConfirmModalShow(false);
    success("取消が完了しました");
    history.push(RoutePaths.root.roy_list);
  }

  return (
    <div>
      {/*内訳一覧*/}
      <div className="body-dtl body-dtl-const">
        <AppNav/>
        <div id="exp-dtl-head" style={{maxWidth: "2000px", margin: "0 auto"}}>
          <Row className="h1">
            <Col sm="3">
              <h1>
                印税内訳
              </h1>
            </Col>
            <Col sm="9" className="text-right">
              <Button as={Link} to={RoutePaths.root.roy_list} variant="quaternary" className="mr-4">
                戻る
              </Button>
              <Button variant="tertiary" className="mr-4" onClick={e => onClickShowConfirmModal()} disabled={!status || status === "支払済"}>
                取消
              </Button>
            </Col>
          </Row>
          <Container className="container-main-detail-header"
                     onKeyDown={(e) => onKeyDownShortCut(e, null, () => onKeyDownCtlEnter(e), () => onKeyDownEsc(e), () => onKeyDownSpace(e), () => onKeyDownEnter(e))}
          >
            <Form.Group as={Row} style={{marginRight: "-15px", marginLeft: "-15px"}}>
              <Form.Label column sm="1" style={{borderTop: "solid 1px #e3e5e9"}}>
                発生日
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col" style={{borderTop: "solid 1px #e3e5e9"}}>
                <div className="input-group">
                  <Form.Control
                    id="expDate"
                    type="text"
                    className="text-center"
                    tabIndex={11}
                    value={expDate}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setExpDate(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setExpDate(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                    autoFocus={true}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalExpDate(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(expDate))}
                  onChange={handleChangeCalPayDate}
                  open={openCalPayDate}
                  onClickOutside={e => setOpenCalPayDate(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Form.Label column sm="1" style={{borderTop: "solid 1px #e3e5e9"}}>
                支払日
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col" style={{borderTop: "solid 1px #e3e5e9"}}>
                <div className="input-group">
                  <Form.Control
                    id="payDate"
                    type="text"
                    className="text-center"
                    tabIndex={12}
                    value={payDate}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDate(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDate(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDate(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDate))}
                  onChange={handleChangeCalPayDate}
                  open={openCalPayDate}
                  onClickOutside={e => setOpenCalPayDate(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Form.Label column sm="1" style={{borderTop: "solid 1px #e3e5e9"}}>
                Gno
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col" style={{borderTop: "solid 1px #e3e5e9"}}>
                <Form.Control
                  type="text"
                  tabIndex={13}
                  inputMode="numeric"
                  style={{borderRadius: "0", textAlign: "center"}}
                  value={payGrpNum}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    onKeyDownNext(e);
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setPayGrpNum(e.target.value)}/>
              </Col>
              <Form.Label column sm="1" style={{borderTop: "solid 1px #e3e5e9"}}>
                ステータス
              </Form.Label>
              <Col sm="1" style={{borderTop: "solid 1px #e3e5e9", paddingTop: "4px"}}>
                <div className={
                  !status ? 'tag-status status-0 text-center' :
                    status === '新規' ? 'tag-status status-00 text-center' :
                      status === '支払前' ? 'tag-status status-01 text-center' :
                        status === '副社長承認中' ? 'tag-status status-10 text-center' :
                          status === '社長承認中' ? 'tag-status status-20 text-center' :
                            status === '処理中' ? 'tag-status status-30 text-center' :
                              status === '支払済' ? 'tag-status status-90 text-center' :
                                'd-inline-block'
                }
                     style={{width: "100px"}}
                >
                  {status ? status : "未作成"}
                </div>
              </Col>
              <Form.Label column sm="1" style={{borderTop: "solid 1px #e3e5e9"}}>
                印税種別
              </Form.Label>
              <Col sm="2" className="p-0" style={{borderTop: "solid 1px #e3e5e9"}}>
                <AsyncSelect
                  tabIndex={14}
                  className="async-select"
                  classNamePrefix="async-select"
                  components={{DropdownIndicator: null, ClearIndicator: null}}
                  cacheOptions
                  defaultOptions
                  value={royTypeCdSelected}
                  onMenuOpen={e => setSelectMenuOpen(true)}
                  onMenuClose={e => setSelectMenuOpen(false)}
                  onKeyDown={e => {
                    if (e.key === "ArrowDown") {
                      setSelectMenuOpen(true);
                    }
                  }}
                  getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                  getOptionValue={e => e.id}
                  loadOptions={e => onSearchRoyTypeCd(e)}
                  onChange={handleChangeRoyTypeCd}
                  placeholder=""
                  isClearable
                />
              </Col>
              <Col sm="1" className="p-0" style={{borderTop: "solid 1px #e3e5e9"}}>
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{borderLeft: "solid 1px #e3e5e9", marginRight: "-15px", marginLeft: "-15px"}}>
              <Form.Label column sm="1">
                商品名
              </Form.Label>
              <Col sm="7" className="p-0">
              <AsyncSelect
                tabIndex={21}
                className="async-select"
                classNamePrefix="async-select"
                components={{DropdownIndicator: null, ClearIndicator: null}}
                cacheOptions
                value={itemSelected}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                // onKeyDown={e => {
                //   if (!selectMenuOpen) {
                //     if (e.key === "ArrowDown") {
                //       setSelectMenuOpen(true);
                //       return;
                //     }
                //     setTimeout(() => {
                //       onKeyDownNext(e);
                //     }, 100);
                //   }
                // }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchItem(e)}
                onChange={e => handleChangeItem(e)}
                placeholder=""
                isClearable
              />
              </Col>
              <Form.Label column sm="1">
                誌別CD
              </Form.Label>
              <Col sm="1" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={volumeNoMagezineCd}/>
              </Col>
              <Form.Label column sm="1">
                誌別NO
              </Form.Label>
              <Col sm="1" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={volumeNoSerialNumber}/>
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{borderLeft: "solid 1px #e3e5e9", marginRight: "-15px", marginLeft: "-15px"}}>
              <Form.Label column sm="1">
                企画コード
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col">
                <Form.Control
                  type="text"
                  tabIndex={31}
                  inputMode="numeric"
                  style={{borderRadius: "0", textAlign: "center"}}
                  value={costCd}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    onKeyDownNext(e);
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setCostCd(e.target.value)}/>
              </Col>
              <Form.Label column sm="1">
                再版
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col">
                <Form.Control
                  type="text"
                  tabIndex={32}
                  inputMode="numeric"
                  style={{borderRadius: "0", textAlign: "center"}}
                  value={version}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    onKeyDownNext(e);
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setVersion(e.target.value)}/>
              </Col>
              <Form.Label column sm="1">
                国コード
              </Form.Label>
              <Col sm="1" className="p-0">
                <AsyncSelect
                  tabIndex={33}
                  className="async-select"
                  classNamePrefix="async-select"
                  components={{DropdownIndicator: null, ClearIndicator: null}}
                  cacheOptions
                  defaultOptions
                  value={countryCdSelected}
                  onMenuOpen={e => setSelectMenuOpen(true)}
                  onMenuClose={e => setSelectMenuOpen(false)}
                  onKeyDown={e => {
                    if (e.key === "ArrowDown") {
                      setSelectMenuOpen(true);
                    }
                  }}
                  getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                  getOptionValue={e => e.id}
                  loadOptions={e => onSearchCountryCd(e)}
                  onChange={handleChangeCountryCd}
                  placeholder=""
                  isClearable
                  isDisabled={!royTypeCd || royTypeCd !== "03"}
                />
              </Col>
              <Form.Label column sm="1">
                出版社
              </Form.Label>
              <Col sm="2" className="p-0">
                <AsyncSelect
                  tabIndex={34}
                  className="async-select"
                  classNamePrefix="async-select"
                  components={{DropdownIndicator: null, ClearIndicator: null}}
                  cacheOptions
                  defaultOptions
                  value={publisherCdSelected}
                  onMenuOpen={e => setSelectMenuOpen(true)}
                  onMenuClose={e => setSelectMenuOpen(false)}
                  onKeyDown={e => {
                    if (e.key === "ArrowDown") {
                      setSelectMenuOpen(true);
                    }
                  }}
                  getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                  getOptionValue={e => e.id}
                  loadOptions={e => onSearchPublisherCd(e)}
                  onChange={handleChangePublisherCd}
                  placeholder=""
                  isClearable
                  isDisabled={!royTypeCd || royTypeCd !== "03"}
                />
              </Col>
              <Form.Label column sm="1">
                エージェント
              </Form.Label>
              <Col sm="2" className="p-0">
                <AsyncSelect
                  tabIndex={35}
                  className="async-select"
                  classNamePrefix="async-select"
                  components={{DropdownIndicator: null, ClearIndicator: null}}
                  cacheOptions
                  defaultOptions
                  value={agentCdSelected}
                  onMenuOpen={e => setSelectMenuOpen(true)}
                  onMenuClose={e => setSelectMenuOpen(false)}
                  onKeyDown={e => {
                    if (e.key === "ArrowDown") {
                      setSelectMenuOpen(true);
                    }
                  }}
                  getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                  getOptionValue={e => e.id}
                  loadOptions={e => onSearchAgentCd(e)}
                  onChange={handleChangeAgentCd}
                  placeholder=""
                  isClearable
                  isDisabled={!royTypeCd || royTypeCd !== "03"}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{borderLeft: "solid 1px #e3e5e9", marginRight: "-15px", marginLeft: "-15px"}}>
              <Form.Label column sm="1">
                部数
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col">
                <Form.Control
                  type="text"
                  tabIndex={41}
                  inputMode="numeric"
                  style={{borderRadius: "0", textAlign: "right"}}
                  value={qty}
                  disabled={!royTypeCd || royTypeCd === "03"}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    onKeyDownNext(e);
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setQty(e.target.value)}
                  onBlur={e => {
                    const cQty = parseNumber(e.target.value);
                    setQty(cQty);
                    setReceiveAmount(amountFormatter(cQty * parseNumber(price)));
                  }}/>
              </Col>
              <Form.Label column sm="1">
                本体価格
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col">
                <Form.Control
                  type="text"
                  tabIndex={42}
                  inputMode="numeric"
                  style={{borderRadius: "0", textAlign: "right"}}
                  value={price}
                  disabled={!royTypeCd || royTypeCd === "03"}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    onKeyDownNext(e);
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setPrice(e.target.value)}
                  onBlur={e => {
                    const cPrice = parseNumber(e.target.value);
                    setPrice(amountFormatter(cPrice));
                    setReceiveAmount(amountFormatter(parseNumber(qty) * cPrice));
                  }}/>
              </Col>
              <Form.Label column sm="1">
                当社入金額
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col">
                <Form.Control
                  type="text"
                  tabIndex={43}
                  inputMode="numeric"
                  style={{borderRadius: "0", textAlign: "right"}}
                  value={receiveAmount}
                  disabled={!royTypeCd || royTypeCd === "01" || royTypeCd === "02"}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    onKeyDownNext(e);
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setReceiveAmount(e.target.value)}
                  onBlur={e => setReceiveAmount(amountFormatter(parseNumber(e.target.value)))}/>
              </Col>
            </Form.Group>
          </Container>
          <Container id="exp-dtl-list" className="container-main-detail-list pb-2">
            <div className="d-flex flex-row mt-1" style={{marginLeft: "-5px", marginRight: "-15px"}}>
              <div className="container" style={{flex: "85 1 0%", padding: "0"}}>
                <Row className="tbl-h-00">
                  <Col lg="1" className="tbl-h-00-top tbl-h-00-start" style={{borderBottom: "none", flex: "0 0 40px", maxWidth: "40px", textAlign:"center"}}>No.</Col>
                  <Col lg="2" className="tbl-h-00-top" style={{flex: "2 1 0%", maxWidth: "none", padding:"0"}}>科目</Col>
                  <Col lg="3" className="tbl-h-00-top" style={{flex: "3 1 0%", maxWidth: "none", padding:"0"}}>受領者</Col>
                  <Col lg="5" className="tbl-h-00-top" style={{flex: "5 1 0%", maxWidth: "none", padding:"0"}}>口座</Col>
                </Row>
                <Row className="tbl-h-00">
                  <Col lg="1" className="tbl-h-00-start" style={{borderBottom: "none", flex: "0 0 40px", maxWidth: "40px"}}></Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>支払区分</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>パーセント</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>金額</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>経費</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>税率</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>消費税</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>経費2</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>合計</Col>
                  <Col lg="1" style={{flex: "1 1 0%", maxWidth: "none"}}>源泉</Col>
                  <Col lg="2" style={{flex: "1 1 0%", maxWidth: "none"}}>支払金額</Col>
                </Row>
                <Row className="tbl-h-00">
                  <Col lg="1" className="tbl-h-00-start" style={{flex: "0 0 40px", maxWidth: "40px"}}></Col>
                  <Col lg="12" style={{flex: "12 1 0%", maxWidth: "none"}}>摘要</Col>
                </Row>
                {lineList.filter((line) => 1 === 1).map((obj, index) => (
                  <RoyDtlLine key={index}
                              ref={lineListRef.current[index]}
                              index={index}
                              line={obj}
                              accList={accList}
                              remarkList={remarkList}
                              appendLine={appendLine}
                              calcTotal={calcTotal}
                              onClickExpSave={onClickExpSave}
                              onKeyDownEsc={onKeyDownEsc}
                              receiveAmount={receiveAmount}
                  />
                ))}
                <Row className="tbl-b-00 pt-1">
                  <Col lg="1" style={{flex: "0 0 40px", maxWidth: "40px", border:"none"}}></Col>
                  <Col sm="1" style={{flex: "1 1 0%", maxWidth: "none", border:"none"}}></Col>
                  <Col sm="1" className="tbl-h-00-h-col text-right" style={{flex: "1 1 0%", maxWidth: "none", fontWeight: "bold"}}>合計</Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="col-num" plaintext readOnly value={formatNumber(subAmount10)}/>
                  </Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="col-num" plaintext readOnly value={formatNumber(subAmountEx1)}/>
                  </Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="text-center" plaintext readOnly value="―"/>
                  </Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="col-num" plaintext readOnly value={formatNumber(taxAmount)}/>
                  </Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="col-num" plaintext readOnly value={formatNumber(subAmountEx2)}/>
                  </Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="col-num" plaintext readOnly value={formatNumber(totalAmount)}/>
                  </Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="col-num" plaintext readOnly value={formatNumber(withholdTaxAmount)}/>
                  </Col>
                  <Col sm="1" className="tbl-b-00-top input-group form-group" style={{flex: "1 1 0%", maxWidth: "none"}}>
                    <Form.Control className="col-num" plaintext readOnly value={formatNumber(payAmount)}/>
                  </Col>
                </Row>
                <div className="pt-1 d-flex justify-content-end" style={{marginRight: "-15px", marginLeft: "-15px"}}>
                    <Button variant="primary" onClick={e => onClickExpSave()} disabled={status === "支払済"}>
                      保存
                    </Button>
                </div>
              </div>
              <div className="container" style={{flex: "15 1 0%"}}>
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start tbl-h-00-top" style={{borderBottom:"1px solid #E3E5E9"}}>金額10%</Col>
                    <Col lg="6" className="col-num tbl-h-00-top" style={{padding: ".375rem", borderBottom:"1px solid #FFFFFF"}}>{amountFormatter(subAmount10)}&nbsp;</Col>
                  </Row>
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start" style={{borderTop:"1px solid #E3E5E9"}}></Col>
                    <Col lg="6" className="col-num" style={{padding: ".375rem"}}>({amountFormatter(taxAmount10)})</Col>
                  </Row>
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start" style={{borderBottom:"1px solid #E3E5E9"}}>経費</Col>
                    <Col lg="6" className="col-num" style={{padding: ".375rem", borderBottom:"1px solid #FFFFFF"}}>{amountFormatter(subAmountEx1)}&nbsp;</Col>
                  </Row>
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start" style={{borderTop:"1px solid #E3E5E9"}}></Col>
                    <Col lg="6" className="col-num" style={{padding: ".375rem"}}>({amountFormatter(taxAmountEx1)})</Col>
                  </Row>
                  <Row className="ml-1 tbl-b-00">
                    <Col lg="6" className="tbl-h-00 tbl-h-00-start">経費2</Col>
                    <Col lg="6" className="col-num" style={{padding: ".375rem"}}>{amountFormatter(subAmountEx2)}&nbsp;</Col>
                  </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">合計金額</Col>
                  <Col lg="6" className="col-num" style={{padding: ".375rem"}}>{amountFormatter(totalAmount)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">源泉金額</Col>
                  <Col lg="6" className="col-num" style={{padding: ".375rem"}}>{amountFormatter(withholdTaxAmount)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">支払金額</Col>
                  <Col lg="6" className="col-num" style={{padding: ".375rem"}}>{amountFormatter(payAmount)}&nbsp;</Col>
                </Row>
              </div>
            </div>
          </Container>
        </div>
      </div>

      {/*確認ダイアログ*/}
      <Modal id="confirm-modal" show={confirmModalShow} onHide={onClickCloseConfirmModal} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>取消確認</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          この経費の支払いを取消してよいですか
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={onClickCloseConfirmModal}>
            いいえ
          </Button>
          <Button variant="danger" onClick={onClickDelete}>
            はい
          </Button>
        </Modal.Footer>
      </Modal>

      {/*ポップアップメッセージ*/}
      <Toast/>
    </div>
  )
    ;
}

export default withRouter(RoyDtl);